export class MobileV1Table {
  constructor() { }

  transform(raw: any) {
    const startDateTime = raw?.startDateTime || raw?.items?.[0]?.timestamp || "";
    const timeStart = this.toOffset(startDateTime, 420); // +07:00

    const name = String(raw?.name ?? "");
    const { zoneMajor, zoneMinor, tableNumber } = this.parseZone(name);

    const itemsCombined = Array.isArray(raw?.items) ? raw.items : [];
    const lines = this.buildLines(itemsCombined);
    const sumDiscountLines = this.round2(
      lines.reduce((acc, l) => acc + this.toNumber(l.discount, 0), 0)
    );
    const hasLineDiscount = sumDiscountLines > 0;

    const billing = raw?.billing ?? {};
    const subTotal = this.round2(this.toNumber(billing.subTotal, 0));
    const grandTotal = this.round2(this.toNumber(billing.grandTotal, subTotal));

    const vat = this.parseVat(billing.vat);
    const service = this.parseCharge(billing.sc || billing.serviceCharge);
    const discount = this.parseDiscount(billing.dc2 || billing.discount);
    const cardCharge = this.parseCharge(billing.cc || billing.cardCharge);

    return {
      comment: "",
      timeStart,
      dateTime: "",
      key: "",
      sync: true,
      numberOfItmes: lines.length,
      lines,
      grandTotal,
      subTotal,
      noOfJobs: Array.isArray(raw?.jobs) ? raw.jobs.length : 0,
      fullAlias: `${raw?.type === "table" ? "Table " : ""}${name || ""}`,
      vat,
      customer: this.toNumber(raw?.guests, 1),
      customerMode: 1,
      service,
      discount,
      sumDiscountLines,
      uuid: String(
        (raw?.itemsCombined?.[0]?.billNumber ??
          raw?.items?.[0]?.billNumber ??
          tableNumber ??
          "")
      ),
      hasLineDiscount,
      total: subTotal,
      cardCharge,
      isLock: false,
      mode: 1,
      printPreviewCount: 0,
      tableNumber: tableNumber ?? "",
      zoneMajor: zoneMajor ?? "",
      zoneMinor: zoneMinor ?? null,
      useZoneV2: true,
      alias: name || "",
      shortAlias: name || "",
      dataChanged: timeStart || "",
    };
  } 


  tranformEmptyData(raw: any) {
    const startDateTime = raw?.startDateTime || raw?.items?.[0]?.timestamp || "";
    const timeStart = this.toOffset(startDateTime, 420); // +07:00

    const name = String(raw?.name ?? "");
    const { zoneMajor, zoneMinor, tableNumber } = raw 

    const itemsCombined = Array.isArray(raw?.items) ? raw.items : [];
    const lines = this.buildLines(itemsCombined);
    const sumDiscountLines = this.round2(
      lines.reduce((acc, l) => acc + this.toNumber(l.discount, 0), 0)
    );
    const hasLineDiscount = sumDiscountLines > 0;

    const billing = raw?.billing ?? {};
    const subTotal = this.round2(this.toNumber(billing.subTotal, 0));
    const grandTotal = this.round2(this.toNumber(billing.grandTotal, subTotal));

    const vat = this.parseVat(billing.vat);
    const service = this.parseCharge(billing.sc || billing.serviceCharge);
    const discount = this.parseDiscount(billing.dc2 || billing.discount);
    const cardCharge = this.parseCharge(billing.cc || billing.cardCharge);

    return {
      comment: "",
      timeStart,
      dateTime: "",
      key: "",
      sync: true,
      numberOfItmes: lines.length,
      lines,
      grandTotal,
      subTotal,
      noOfJobs: Array.isArray(raw?.jobs) ? raw.jobs.length : 0,
      fullAlias: `${raw?.type === "table" ? "Table " : ""}${name || ""}`,
      vat,
      customer: this.toNumber(raw?.guests, 1),
      customerMode: 1,
      service,
      discount,
      sumDiscountLines,
      uuid: String(
        (raw?.itemsCombined?.[0]?.billNumber ??
          raw?.items?.[0]?.billNumber ??
          tableNumber ??
          "")
      ),
      hasLineDiscount,
      total: subTotal,
      cardCharge,
      isLock: false,
      mode: 1,
      printPreviewCount: 0,
      tableNumber: tableNumber ?? "",
      zoneMajor: zoneMajor ?? "",
      zoneMinor: zoneMinor ?? null,
      useZoneV2: true,
      alias: name || "",
      shortAlias: name || "",
      dataChanged: timeStart || "",
    };
  }

  // ---------- helpers ----------
  toNumber(v, def = 0) {
    return Number.isFinite(Number(v)) ? Number(v) : def;
  }

  round2(n) {
    return Math.round((this.toNumber(n) + Number.EPSILON) * 100) / 100;
  }

  ensureArray(val) {
    return Array.isArray(val) ? val : [0, 0, 0];
  }

  modeNameFromMode(mode) {
    if (mode === 1) return "Included";
    if (mode === 2) return "Excluded";
    return "";
  }

  fmtPercentText(percent, modeName) {
    const p = this.round2(percent);
    const pStr = Number.isFinite(p) ? `${p}%` : `0%`;
    return `${pStr}${modeName ? ` (${modeName})` : ""}`;
  }

  parseVat(vatArr) {
    const [mode, percent, amount] = this.ensureArray(vatArr);
    const text = `${this.round2(percent)}%${mode ? ` (${this.modeNameFromMode(mode)})` : ""
      }`;
    return { amount: this.round2(amount), text };
  }

  parseCharge(arr) {
    const [mode, percent, amount] = this.ensureArray(arr);
    return { amount: this.round2(amount), text: this.fmtPercentText(percent) };
  }

  parseDiscount(arr) {
    const [mode, percent, amount] = this.ensureArray(arr);
    return { amount: this.round2(amount), text: this.fmtPercentText(percent) };
  }

  toOffset(dateStr, offsetMinutes = 420) {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return "";
    const localMs = d.getTime() + offsetMinutes * 60 * 1000;
    const z = new Date(localMs).toISOString().replace("Z", "");
    const base = z.slice(0, 19);
    const sign = offsetMinutes >= 0 ? "+" : "-";
    const abs = Math.abs(offsetMinutes);
    const hh = String(Math.floor(abs / 60)).padStart(2, "0");
    const mm = String(abs % 60).padStart(2, "0");
    return `${base}${sign}${hh}:${mm}`;
  }

  parseZone(name) {
     
    if (!name || typeof name !== "string") {
      return { zoneMajor: "", zoneMinor: null, tableNumber: "" };
    }
    const m = name.match(/^([A-Za-z]+)(\d+)$/);
    if (!m) return { zoneMajor: name, zoneMinor: null, tableNumber: "" };
    const zoneMajor = m[1].toUpperCase();
    const zoneMinor = Number(m[2]);
    return { zoneMajor, zoneMinor, tableNumber: String(zoneMinor) };
  }

  buildLines(itemsCombined = []) {
    return itemsCombined.map((it) => {


      const discountMode = it.dc1?.[0] ?? 0;
      const discountValue = it.dc1?.[1] ?? 0;
      const discountAmount = it.dc1?.[2] ?? 0;
      // A baht value is PER PIECE, so spell out the ×qty exactly like the legacy
      // app did (`ลด -30.00 X 5`).
      const discountText = discountAmount > 0
        ? (discountMode === 1
          ? `ลด -${this.toNumber(discountValue, 0).toFixed(2)} X ${it.quantity ?? 0}`
          : `ลด ${discountValue}%`)
        : "";

      return {
        uniqueId: String(it.uuid ?? `${Date.now()}`),
        subItemId: this.toNumber(it.subItemId, 0),
        name: String(it.name ?? ""),
        comments: it.comments || "",  // ในมือถือไม่แสดง ไม่มีค่าพร็อพนี้

        price: it.price,  //ok
        discount: it.dc1[2],
        discountText,
        discountedPrice: it.discountedPrice,
        discountRequest: {
          mode: discountMode,
          value: discountValue,
          amount: discountAmount
        },
        quantity: it.quantity,
        extendedPrice: it.extendedPrice,
        toppings: it.toppings || [],
      };
    });
  }
}
